var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticStyle:{"text-align":"center"}},[_c('h1',[_vm._v("404 not found")]),_c('h2',[_vm._v("it seems you're in the wrong page")])])])
}]

export { render, staticRenderFns }